import { render, staticRenderFns } from "./page-language.vue?vue&type=template&id=3136454d&"
import script from "./page-language.vue?vue&type=script&lang=ts&"
export * from "./page-language.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports